// extracted by mini-css-extract-plugin
export default {"container":"Address_container__Ne4ke"};